import { call, put } from "redux-saga/effects";
import { fetchAllPlayers } from "../../../api";
import { profileActions } from "../../../actions/profile";

export function* fetchAllPlayersSaga({ payload: { gameId } }) {
  console.log('Fetching all players with:', { gameId });
  const res = yield call(fetchAllPlayers, gameId);
  if (res.response) {
    yield put(profileActions.fetchAllPlayersSuccess(res.response));
  } else if (res.error) {
    yield put(profileActions.fetchAllPlayersFailure(res.error));
  }
} 